import React from 'react';
import { useTenantBranding } from '@/context/TenantBranding';

const FollowUpSuccessStep = ({ submissionId, userName, onStartOver }) => {
  const { dashboardUrl } = useTenantBranding();
  return (
    <div className="text-center" data-testid="followup-success-step">
      {/* Success Icon */}
      <div className="w-20 h-20 bg-[#e8f5ee] rounded-full flex items-center justify-center mx-auto mb-6">
        <svg className="w-10 h-10 text-[#2d8a5f]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
        </svg>
      </div>
      
      {/* Success Message */}
      <h2 className="text-2xl md:text-3xl font-semibold text-gray-900 mb-4">
        Thank You, {userName}!
      </h2>
      
      <p className="text-gray-500 mb-6 max-w-md mx-auto">
        Your follow-up questionnaire has been submitted successfully. Our medical team will review your responses and get back to you shortly.
      </p>
      
      {/* Submission ID */}
      {submissionId && (
        <div className="bg-gray-50 rounded-xl p-4 mb-6 max-w-md mx-auto">
          <p className="text-sm text-gray-500 mb-1">Reference Number</p>
          <p className="font-mono text-sm text-gray-700">{submissionId}</p>
        </div>
      )}
      
      {/* Next Steps */}
      <div className="bg-[#f0faf4] rounded-xl p-6 mb-6 max-w-md mx-auto text-left">
        <h3 className="font-semibold text-gray-900 mb-3">What happens next?</h3>
        <ul className="space-y-2 text-sm text-gray-600">
          <li className="flex items-start gap-2">
            <svg className="w-5 h-5 text-[#2d8a5f] flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
            </svg>
            <span>A provider will review your responses within 24-48 hours</span>
          </li>
          <li className="flex items-start gap-2">
            <svg className="w-5 h-5 text-[#2d8a5f] flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
            </svg>
            <span>You'll receive an email with any updates or additional instructions</span>
          </li>
          <li className="flex items-start gap-2">
            <svg className="w-5 h-5 text-[#2d8a5f] flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
            </svg>
            {/* §preference-not-prescription: a follow-up can change the product
                or dose; the provider decides, not the patient's selection. */}
            <span>Your provider may adjust your treatment plan based on your feedback &mdash; the treatment prescribed may differ from the option you selected</span>
          </li>
        </ul>
      </div>
      
      {/* Action Buttons */}
      <div className="space-y-3 max-w-md mx-auto">
        <a
          href={dashboardUrl}
          className="block w-full py-3 px-4 bg-[#2d8a5f] text-white font-semibold rounded-xl hover:bg-[#246f4d] transition-colors"
          data-testid="dashboard-login-btn"
        >
          Go to my dashboard
        </a>
        <button
          onClick={onStartOver}
          className="w-full py-3 px-4 text-gray-600 hover:text-gray-900 hover:bg-gray-100 rounded-xl transition-colors"
          data-testid="start-over-button"
        >
          Submit Another Response
        </button>
      </div>
      
      {/* Copyright */}
      <div className="mt-8 pt-6 border-t border-gray-100">
        <p className="text-xs text-gray-400">
          © 2026 Beluga Health. All Rights Reserved.
        </p>
      </div>
    </div>
  );
};

export default FollowUpSuccessStep;
